module.exports = __webpack_public_path__ + "img/project3.914df552.jpeg";